<template>
  <div id="app">
    <router-view />
    <ElectronInfo v-if="showElectronInfo" />
    <UpdateNotification ref="updateNotification" />
  </div>
</template>

<script>
import ElectronInfo from './components/ElectronInfo.vue';
import UpdateNotification from './components/UpdateNotification.vue';

export default {
  name: 'App',
  components: {
    ElectronInfo,
    UpdateNotification
  },
  data() {
    return {
      showElectronInfo: true // 可以根据需要控制是否显示Electron信息
    };
  },
  mounted() {
    this.$nextTick(() => {
      let userInfo = localStorage.getItem('k_userInfo')
      if (!userInfo) {
        this.$router.push('/login')
      }
      const debugPanels = document.querySelectorAll('.debug-panel, .route-info, .debug-info, [class*="debug"]');
      debugPanels.forEach(panel => {
        if (panel && panel.parentNode) {
          panel.parentNode.removeChild(panel);
        }
      });
      
      const yellowElements = Array.from(document.querySelectorAll('*')).filter(el => {
        const style = window.getComputedStyle(el);
        return style.backgroundColor.includes('255, 255, 0') || 
               style.backgroundColor.includes('yellow') ||
               style.backgroundColor.includes('#ffff');
      });
      
      yellowElements.forEach(el => {
        if (el && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    });
  },
  methods: {
    // 提供给其他组件调用的手动检查更新方法
    checkForUpdates() {
      if (this.$refs.updateNotification) {
        this.$refs.updateNotification.checkForUpdates();
      }
    }
  }
}
</script>

<style>
.app-container {
  width: 100%;
  height: 100vh;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
}
</style> 